<template>
    <div class="vx-row m-0 main-list-panel">
        <h5 class="names_title">Public Charge</h5>
        <booleanDetails v-if="canRenderField('inadmissibility',questionnaireDetails, false, tplsection) && checkBooleanValue('inadmissibility')"
        :label="'Are you subject to the public charge ground of inadmissibility under INA section 212(a)(4)'" 
        :fieldValue="checkProperty(petition ,'inadmissibility')" :wrapclass="'w-full'"  />
        <template v-if="checkProperty(petition ,'inadmissibility')">
            <div class="vx-col w-full p-0" v-if="checkProperty(petition,'highestDegreeCompleted') && checkProperty(petition,'highestDegreeCompleted' ,'name')">
                <div class="main-list">
                    <p>
                        What is the highest degree or level of school you have completed
                        <span>{{checkProperty(petition,'highestDegreeCompleted' ,'name')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col  md: w-full p-0" v-if="checkProperty(petition  ,'listOfCertifications')">
                <div class="main-list">
                    <p>
                        List your certifications, licenses, skills obtained through work experience, and educational certificates
                        <span class="ownership_details" v-html="checkProperty(petition  ,'listOfCertifications')"></span>
                    </p>
                </div> 
            </div>
            <div class="list_items_grid">
                <booleanDetails v-if="canRenderField('SSI',questionnaireDetails, false, tplsection) && checkBooleanValue('SSI')"
                :label="'Have you ever received Supplemental Security Income (SSI), Temporary Assistance for Needy Families (TANF), or State, Tribal, territorial, or local, cash benefit programs for income maintenance'" 
                :fieldValue="checkProperty(petition ,'SSI')" :wrapclass="'w-full'"  />

                <template v-if="canRenderField('SSI',questionnaireDetails, false, tplsection) && checkProperty(petition ,'SSI') && 
                checkProperty(petition, 'benefitsRecAmounts') && checkProperty(petition, 'benefitsRecAmounts', 'length')>0">
                    <div class="list_items_info">
                        <template v-for="(item , ind)  in petition['benefitsRecAmounts']">
                            <div class="vx-row">
                                <div :key="ind" class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(item, 'benefitReceived')">
                                    <div class="main-list">
                                        <p>Benefit Received<span>{{item.benefitReceived}}</span></p>
                                    </div>
                                </div>
                                <div :key="ind" class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(item, 'startDate')">
                                    <div class="main-list">
                                        <p>Start Date<span>{{item.startDate | formatDate}}</span></p>
                                    </div>
                                </div>
                                <div :key="ind" class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(item, 'endDate')">
                                    <div class="main-list">
                                        <p>End Date<span>{{item.endDate | formatDate}}</span></p>
                                    </div>
                                </div>
                                <div :key="ind" class="vx-col md:w-1/4 w-full p-0" v-if="checkProperty(item, 'amount')">
                                    <div class="main-list">
                                        <p>Amount($)<span>{{item.amount | formatprice}}</span></p>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
            <div class="list_items_grid">
                <booleanDetails v-if="canRenderField('longTermInstiAtGovtExpense',questionnaireDetails, false, tplsection) && checkBooleanValue('longTermInstiAtGovtExpense')"
                :label="'Have you ever received long-term institutionalization at government expense'" 
                :fieldValue="checkProperty(petition ,'longTermInstiAtGovtExpense')" :wrapclass="'w-full'"  />

                <template v-if="canRenderField('longTermInstiAtGovtExpense',questionnaireDetails, false, tplsection) && checkProperty(petition ,'longTermInstiAtGovtExpense') && 
                checkProperty(petition, 'periodOfInstutions') && checkProperty(petition, 'periodOfInstutions', 'length')>0">
                <div class="list_items_info">
                    <template v-for="(item , ind)  in petition['periodOfInstutions']">
                        <div class="vx-row">
                            <div :key="ind" class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(item, 'institutionName')">
                                <div class="main-list">
                                    <p>Institution Name<span>{{item.institutionName}}</span></p>
                                </div>
                            </div>
                            <div :key="ind" class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(item, 'stateDetails') && checkProperty(item, 'stateDetails', 'name')">
                                <div class="main-list">
                                    <p>State<span>{{checkProperty(item, 'stateDetails', 'name')}}</span></p>
                                </div>
                            </div>
                            <div :key="ind" class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(item, 'locationDetails') && checkProperty(item, 'locationDetails', 'name')">
                                <div class="main-list">
                                    <p>City<span>{{checkProperty(item, 'locationDetails', 'name')}}</span></p>
                                </div>
                            </div>
                            <div :key="ind" class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(item, 'dateFrom')">
                                <div class="main-list">
                                    <p>Date From<span>{{item.dateFrom | formatDate}}</span></p>
                                </div>
                            </div>
                            <div :key="ind" class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(item, 'dateTo')">
                                <div class="main-list">
                                    <p>Date To<span>{{item.dateTo | formatDate}}</span></p>
                                </div>
                            </div>
                            <div :key="ind" class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(item, 'reason')">
                                <div class="main-list">
                                    <p>Reason<span>{{item.reason}}</span></p>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                </template>
            </div>
        </template>


    </div>
</template>
<script>
import booleanDetails  from "@/views/detailsFields/booleanDetails.vue"; 
export default {
    data: ()=>({
        visastatuses:[],
    }),
    props: {
        petition: {
            type: Object,
            default: null
        },
        tplsection:{
            type:String,
            default:'beneficiaryInfo'
        },
        questionnaireDetails:{
            type: Array,
            default: null
        }
    },
    components:{
        booleanDetails
    },
    methods:{
        checkBooleanValue(key){
            let returnVal = false;
            if(this.checkProperty(this.petition, key) === true || this.checkProperty(this.petition, key) === 'true' ||
            this.checkProperty(this.petition, key) === false || this.checkProperty(this.petition, key) === 'false'){
                returnVal = true;
            }
            return returnVal;
        },
    }
}
</script>